import { useContext } from "react";
import { CorporateGroupTravelContext } from "../CorporateGroupTravel";
import { ICorporateGroupTravelContext } from "../config/interfaces";
import CGOrderDetails from "./step/CGOrderDetails";
import CGOrderForm from "./step/CGOrderForm";
import CGPaymentForm from "./step/CGPaymentForm";
import CGQuoteDetail from "./step/CGQuoteDetail";
import CGQuoteForm from "./step/CGQuoteForm";

const Step = () => {
  const { currentStep } = useContext(CorporateGroupTravelContext) as ICorporateGroupTravelContext;

  let stepContent: JSX.Element;

  switch (currentStep) {
    case 0:
      stepContent = <CGQuoteForm />;
      break;
    case 1:
      stepContent = <CGQuoteDetail />;
      break;
    case 2:
      stepContent = <CGOrderForm />;
      break;
    case 3:
      stepContent = <CGPaymentForm />;
      break;
    case 4:
      stepContent = <CGOrderDetails />;
      break;

    default:
      stepContent = <CGQuoteForm />;
      break;
  }

  return stepContent;
};

export default Step;
